import DirectoryProfileHeader from './DirectoryProfileHeader';

export default DirectoryProfileHeader;
